exports.f = require('./_wks');


/*****************
 ** WEBPACK FOOTER
 ** /home/onlygamescl/onlygames-front/shared/~/core-js/library/modules/_wks-ext.js
 ** module id = 38
 ** module chunks = 1
 **/